import { and, eq, type WhereCondition } from './filterHelpers.ts';

export type FilterValue = string | number | boolean | WhereCondition | Record<string, unknown>;

export const buildClauseFromGroup = (grp: Record<string, FilterValue>): WhereCondition => {
  const parts: WhereCondition[] = [];

  Object.entries(grp).forEach(([field, value]) => {
    if (typeof value === 'string' || typeof value === 'boolean' || typeof value === 'number') {
      parts.push(eq(field, value));
    } else if (typeof value === 'object' && value !== null) {
      parts.push({ [field]: value } as WhereCondition);
    }
  });

  return and(...parts);
};

export const buildDefaultClausesFromGroups = (groups: Record<string, FilterValue>[]): WhereCondition[] => {
  return groups.map(grp => buildClauseFromGroup(grp));
};
